<template>
  <div
    v-for="(subCat, i) in category.childrenItems"
    :key="i"
    class="ml-5"
  >
    <NuxtLink
      :to="th.getCatLink([parentCategory, subCat])"
      class="mb-1 block px-2 py-1 text-base text-neutral-900 hover:text-primary-700"
      :class="{ '!font-bold': isParentCategory(subCat), '!font-normal !text-primary-700': isActiveCategory(subCat) }"
    >
      {{ subCat.name }}
    </NuxtLink>
    <template v-if="isParentCategory(subCat)">
      <div
        v-for="(subSubCat) in subCat.childrenItems"
        :key="subSubCat.name"
        class="ml-5"
      >
        <NuxtLink
          :to="th.getCatLink([parentCategory, subSubCat])"
          class="mb-1 block px-2 py-1 text-base text-neutral-900 hover:text-primary-700"
          :class="{ '!text-primary-700': isParentCategory(subSubCat) }"
        >
          {{ subSubCat.name }}
        </NuxtLink>
      </div>
    </template>
  </div>
</template>

<script lang="ts" setup>
import useUiHelpers from '~/composables/useUiHelpers';

interface Props {
  parentCategory: NavbarCategory;
  category: NavbarCategory;
}

defineProps<Props>();

const th = useUiHelpers();
const route = useRoute();

const {
  slug_1: slug1,
  slug_2: slug2,
  slug_3: slug3,
  slug_4: slug4,
} = route.params;

const isParentCategory = (currentCategory: NavbarCategory) => {
  const [lastParam] = [slug4, slug3, slug2, slug1].filter(item => !item?.includes('c_')).filter(Boolean);
  const allChildSlugs = currentCategory.childrenItems?.map(item => item.slug) || [currentCategory.slug];

  const allSlugCategories = [currentCategory.slug, ...allChildSlugs];
  return allSlugCategories.some(slug => slug === lastParam);
};

const isActiveCategory = (currentCategory: NavbarCategory) => {
  const [lastParam] = [slug4, slug3, slug2, slug1].filter(item => !item?.includes('c_')).filter(Boolean);
  return currentCategory.slug === lastParam;
};
</script>

<script lang="ts">
// FIXME
export default defineComponent({
  middleware: 'cache-control',
  transition: 'fade',
});
</script>
